import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function GatesConfirmDialog({ warnings = [], onConfirm, onCancel }) {
  const { t } = useTranslation()
  const [confirmed, setConfirmed] = useState(false)
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4" role="dialog" aria-modal="true" aria-labelledby="playbook-gates-title">
      <div className="w-full max-w-md rounded-xl bg-white p-5 shadow-xl">
        <h2 id="playbook-gates-title" className="text-base font-semibold text-slate-900">{t('playbook.gates.title')}</h2>
        <ul className="mt-3 list-disc space-y-1 pl-5 text-sm text-slate-600">
          {warnings.map((warning) => <li key={warning}>{t(`playbook.gates.warning.${warning}`, { defaultValue: warning })}</li>)}
        </ul>
        <label className="mt-4 flex items-start gap-2 text-sm text-slate-700">
          <input type="checkbox" checked={confirmed} onChange={(event) => setConfirmed(event.target.checked)} />
          <span>{t('playbook.gates.acknowledge')}</span>
        </label>
        <div className="mt-5 flex justify-end gap-2">
          <button type="button" className="rounded-lg border border-slate-200 px-3 py-2 text-sm" onClick={onCancel}>{t('playbook.gates.cancel')}</button>
          <button type="button" className="rounded-lg bg-slate-900 px-3 py-2 text-sm font-semibold text-white disabled:opacity-40" disabled={!confirmed} onClick={() => onConfirm?.(true)}>{t('playbook.gates.confirm')}</button>
        </div>
      </div>
    </div>
  )
}
